import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private notificationService: NotificationService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Statuses that should trigger a forced logout
        const logoutStatuses = [401];

        if (
          logoutStatuses.includes(error.status) &&
          !request.url.includes('/auth/login')
        ) {
          const reason = error.error?.reason || error.error?.message || error.message || 'Unauthorized access';
          this.notificationService.errorMessage(reason);
          this.authService.logout();
        }

        return throwError(() => error);
      }),
    );
  }
}
